<script>
    import Button from "@smui/button/Button.svelte";

    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";

    import loading from "../../components/loading";
    import snackbar from "../../components/snackbar";
    import title from "../../components/title";
    import { post } from "../../http";
    import { getObject, setObject } from "../../session";

    export let location;
    let orders = [];
    let origOrders = [];
    let total = 0;

    function calculateTarif(originCode, order) {
        post("/api/calculate_fee", {
            origin_code: originCode,
            destination_code: order.destination_code,
            weight: order.parcel_weight,
        }).then((resp) => {
            if (resp.status == 0 && resp.data != null) {
                const pkg = resp.data.find(
                    (val) => val.service == order.delivery_type
                );
                if (pkg != null) {
                    order.tarif = pkg.tariff;
                    orders = [...orders, order];
                    total += +order.tarif + +order.insurance;
                } else {
                    //TODO kalau gak ketemu jenis paket yang sama
                }
            }
        });
    }

    function recalculateAllTariff() {
        const pickup = getObject("pickup");
        loading.show();
        orders = [];
        total = 0;
        origOrders.forEach((el) => {
            if (pickup.origin_code == el.origin_code) {
                orders = [...orders, el];
                total += +el.tarif + +el.insurance;
            } else calculateTarif(pickup.origin_code, el);
        });
        if (orders.length == origOrders.length) loading.hide();
    }

    function remove(order_id) {
        if (confirm("Anda yakin menghapus order ini?")) {
            loading.show();
            post("/api/pickup_delete", { order_id: order_id })
                .then((resp) => {
                    if (resp.status == 0) {
                        refresh();
                    } else snackbar.open(resp.message);
                })
                .finally(() => loading.hide());
        }
    }

    function next() {
        const pickup = getObject("pickup");
        pickup["amount"] = total;
        setObject("pickup", pickup);
        navigate("/pickup/payment");
    }

    function refresh() {
        loading.show();
        origOrders = [];
        post("/api/pickup_orders")
            .then((resp) => {
                if (resp.status == 0) {
                    origOrders = resp.data;
                    recalculateAllTariff();
                }
                // else snackbar.open(resp.message);
            })
            .finally(() => loading.hide());
    }

    onMount(() => {
        title.set("Pickup Paket");
        refresh();
    });
</script>

<style lang="scss">
    .address {
        border-top: 1px solid #ccc;
        padding: 8px;

        &:last-child {
            border-bottom: 1px solid #ccc;
        }
    }
    .footer {
        color: #fff;
        background-color: #333;
        height: 56px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 8px;
    }
</style>

<div class="content">
    <div class="caption">Berikut paket yang akan dipickup</div>
    {#each orders as order}
        <div class="address">
            <div class="row">
                {order.recipient_name}
                ({order.recipient_phone})

                <div class="fill" />
                <a
                    href="#delete"
                    on:click={() => remove(order.orderid)}>Hapus</a>
            </div>
            <div>
                {order.recipient_district},
                {order.recipient_city},
                {order.recipient_province}
            </div>
            <div>{order.parcel_category} {order.parcel_weight}Kg</div>
            <div>
                {order.delivery_type}
                Rp.{+order.insurance + +order.tarif}
                {#if +order.insurance > 0}({+order.insurance}){/if}
            </div>
        </div>
    {/each}
</div>
<div class="footer row gap vcenter">
    <div class="column fill">
        <div class="row">
            <div class="fill">Total:</div>
            Rp.{total}
        </div>
    </div>
    <div>
        <Button on:click={next} variant="unelevated" class="rounded">
            Lanjutkan
        </Button>
    </div>
</div>
